import { render, staticRenderFns } from "./ListaQuestoes.vue?vue&type=template&id=4d25b308"
import script from "./ListaQuestoes.vue?vue&type=script&lang=js"
export * from "./ListaQuestoes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports